module.exports = {
	config: {
		usage: 'management' // NOTE: 	"management" is used by default (address management)
							// 			"selection" is used to select an address (e.g., for address connections) instead of editing one.
	},

	events: {
		action: {
			type: 'click',
			selector: 'section.top button',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target);
				if($target.length > 0){
					var fieldType = $target.data('fieldType');
					if(self.model.entityTable){
						if(fieldType === 'assignTagsByFilter'){
							self.model.entityTable.assignTagsByFilter()
						} else if(fieldType === 'export'){
							self.model.entityTable.export()
						} else if(fieldType === 'showInsert'){
							self.model.entityTable.showInsert()
						} else if(fieldType === 'refresh'){
							self.model.entityTable.refreshData()
						}
					}
				}
			}
		}
	},

	methods: {
		typesChanged: function(){
			// NOTE: OVERWRITE THIS
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.entityTable){
				self.find('base_tableSimple_table', function(entityTable){
					self.model.entityTable = entityTable;
				});
			}
		}
	}

}